module.exports = __webpack_public_path__ + "prod/1.42.2/img/cycle-eight.cff289fe.png";